import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const MapaList = props => <DefaultDataTable data={props} />;
